var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("small", [_vm._v("Prefer Country: ")]),
      _vm._v(" "),
      _c(
        "vs-dropdown",
        { staticClass: "cursor-pointer", attrs: { "vs-trigger-click": "" } },
        [
          _c(
            "small",
            { staticClass: "flex cursor-pointer" },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$store.getters.getUserCountry.name))
              ]),
              _vm._v(" "),
              _c("feather-icon", {
                staticClass: "ml-1",
                attrs: { icon: "ChevronDownIcon", svgClasses: "h-4 w-4" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "vs-dropdown-menu",
            { staticClass: "w-32" },
            _vm._l(_vm.$store.state.country.country_list, function(
              country,
              index
            ) {
              return _c(
                "vs-dropdown-item",
                {
                  key: "country_list_" + index,
                  on: {
                    click: function($event) {
                      return _vm.onClickDropdownItem(country)
                    }
                  }
                },
                [_vm._v(_vm._s(country.name))]
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }